import { FC } from 'react';

import { ArrowUpOutlinedSize16, PenSquareOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import styles from './legend-icon.less';

interface LegendIconProps {
    type: 'edit' | 'prolongation';
}

const typeToIcon = {
    edit: <PenSquareOutlinedSize16 initialColor="primary" />,
    prolongation: <ArrowUpOutlinedSize16 initialColor="primary" />,
};

const LegendIcon: FC<LegendIconProps> = ({ type }) => {
    return <div className={styles.legendIcon}>{typeToIcon[type]}</div>;
};

export default LegendIcon;
